import { Facebook, Instagram } from 'lucide-react';
import { useSiteContent } from '../hooks/useSiteContent';
import { SOCIAL_NETWORKS, type SocialNetwork } from '../lib/siteContent';
import { cn } from '../lib/utils';

// Colore e icona di ogni marchio: riconoscibili a colpo d'occhio, come i
// pulsanti "Seguici su …" dei negozi locali.
const STYLES: Record<SocialNetwork, { className: string; icon: typeof Instagram }> = {
  Instagram: {
    className: 'bg-gradient-to-r from-[#F58529] via-[#DD2A7B] to-[#8134AF] hover:brightness-110',
    icon: Instagram,
  },
  Facebook: {
    className: 'bg-[#1877F2] hover:brightness-110',
    icon: Facebook,
  },
};

/** Pulsanti grandi "Seguici su …", uno per profilo compilato in Contenuti → Contatti e social. */
export default function SocialButtons({ className }: { className?: string }) {
  const { content: contacts } = useSiteContent('site.contacts');
  const links = SOCIAL_NETWORKS.filter((name) => contacts.social[name]);
  if (links.length === 0) return null;

  return (
    <div className={cn('flex w-full flex-col gap-3', className)}>
      {links.map((name) => {
        const { className: styleClass, icon: Icon } = STYLES[name];
        return (
          <a
            key={name}
            href={contacts.social[name]}
            target="_blank"
            rel="noopener noreferrer"
            className={cn(
              'flex min-h-14 items-center justify-center gap-3 rounded-xl px-6 py-3 text-base font-bold uppercase tracking-wide text-white shadow-md transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
              styleClass
            )}
          >
            <Icon className="h-6 w-6 shrink-0" aria-hidden="true" />
            Seguici su {name}
          </a>
        );
      })}
    </div>
  );
}
